<template>
  <b-modal
    title="Meet now?"
    v-model="showModal"
    :ok-disabled="form.name === ''"
    ok-title="Start"
    @ok.prevent="submit"
    @cancel.prevent="cancel"
    @hidden="cancel"
  >
    <b-form @submit.prevent>
      <b-form-group
        label="Name"
        label-for="meeting-name"
        invalid-feedback="Please enter a name"
      >
        <b-form-input
          id="meeting-name"
          v-model.trim="form.name"
          required
          maxlength="100"
          :state="errors.length == 0 ? null : form.name ? null : false"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="Type"
        label-for="meeting-type">
        <b-form-select
          id="meeting-type"
          v-model="form.type"
        >
          <option v-if="!isKickoffCreated" value="Kick-Off Meeting">Kick-Off Meeting</option>
          <option value="Weekly Project Meeting">Weekly Project Meeting</option>
          <option value="Partnering Meeting">Partnering Meeting</option>
          <option value="Executive Session">Executive Session</option>
          <option value="Closeout Meeting">Closeout Meeting</option>
          <option value="Other">Other</option>
        </b-form-select>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  props: {
    projectId: { type: String, required: true },
    isKickoffCreated: { type: Boolean, default: false },
  },
  data() {
    return {
      showModal: false,
      form: this.newForm(),
      errors: []
    }
  },
  computed: {
    defaultMeetingType() {
      return !this.isKickoffCreated ?
        "Kick-Off Meeting" :
        "Weekly Project Meeting";
    }
  },
  methods: {
    show() {
      this.reset();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    cancel() {
      this.reset();
      this.hide();
    },
    submit() {
      this.errors = [];
      if (this.form.name == '') {
        this.errors.push('This is wrong');
        return;
      }
      // this.$emit("submit", this.form);
      this.startInstantMeeting(this.form);
      this.cancel();
    },
    reset() {
      this.form = this.newForm();
    },
    newForm() {
      return {
        name: '',
        type: this.defaultMeetingType
      };
    },
    startInstantMeeting(data) {
      let meetingId = this.$helpers.generateUUID();
      let request = {
        meetingId: meetingId,
        projectId: this.projectId,
        meetingDate: new Date(),
        status: "Open",
        name: data.name,
        type: data.type,
      };
      
      const isKickoffMeeting = data.type === 'Kick-Off Meeting';
      
      const url = `${this.$api_url}/meeting`;
      
      const route = isKickoffMeeting ?
        {
          name: "MeetingKickoff",
          params: { id: this.projectId, meetingId: meetingId },
        } :
        {
          name: "Meeting",
          params: { id: this.projectId, meetingId: meetingId },
        };

      axios
        .put(url, request, this.getReqConfig())
        .then(() => {
          this.$router.push(route);
        })
        .catch(() => {
          this.errors.push("Unable to create Instant Meeting");
        });
    },
  }
}
</script>